import { createPortal } from "react-dom"

type Props = {
  title: React.ReactNode
  onClose: () => void
  children: React.ReactNode
  footer?: React.ReactNode
  size?: "default" | "lg"
}

const Modal = ({ title, onClose, children, footer, size = "default" }: Props) =>
  createPortal(
    <div className="modal-overlay" onClick={e => e.target === e.currentTarget && onClose()}>
      <div className={`modal${size === "lg" ? " modal--lg" : ""}`} onClick={e => e.stopPropagation()}>
        <div className="modal__header">
          <span className="modal__title">{title}</span>
          <button className="modal__close" onClick={onClose} aria-label="閉じる">
            <i className="bi bi-x-lg" />
          </button>
        </div>
        <div className="modal__body">{children}</div>
        {footer && <div className="modal__footer">{footer}</div>}
      </div>
    </div>,
    document.body
  )

export default Modal
